import { render } from "./NotificationsGrid.vue?vue&type=template&id=2ab305be"
import script from "./NotificationsGrid.vue?vue&type=script&lang=js"
export * from "./NotificationsGrid.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__